import { useState, useCallback } from 'react'

export const useToggleState = (initialState) => {
  const [value, setValue] = useState(initialState)

  const toggle = useCallback(() => setValue((prev) => !prev), [])

  return [value, toggle]
}
